import React from "react";
import { Grid, Skeleton } from "@mui/material";
import FeatureOptionItem from "./FeatureOptionItem";


/**
 * @param {{
 *   features?: string[],
 *   loading?: boolean,
 *   featureDetails?: import('../../../../types/Location').LocationFeatureDetailsByName | null,
 *   showDetails?: boolean,
 * }} props
 */
const FeaturesOptionsMap = ({ features, loading, featureDetails, showDetails = false }) => {

    return (
        <Grid wrap="wrap" container justifyContent="space-between" alignItems={showDetails ? 'flex-start' : 'center'} className='ss-location-features-option-item-parent'>
            {loading ? [...Array(20).keys()].map((_, index) => <Grid key={index} item className='ss-location-features-option-item'>
                <Skeleton width={'90%'} height={25} variant="text" />
            </Grid>) : features?.map((feature) => (
                <FeatureOptionItem key={feature} feature={feature} details={featureDetails?.[feature]} showDetails={showDetails} />
            ))}
        </Grid>
    )
}

export default FeaturesOptionsMap;
